/**
 * Small, failure-tolerant wrapper over localStorage. Private browsing, blocked
 * storage or quota errors must never break joining a game.
 */
export function readJson(key) {
    try {
        const raw = globalThis.localStorage?.getItem(key);
        return raw ? JSON.parse(raw) : null;
    }
    catch {
        return null;
    }
}
export function writeJson(key, value) {
    try {
        globalThis.localStorage?.setItem(key, JSON.stringify(value));
    }
    catch {
        /* storage unavailable — the game still works, just without auto-rejoin */
    }
}
export function removeKey(key) {
    try {
        globalThis.localStorage?.removeItem(key);
    }
    catch {
        /* ignore */
    }
}
/**
 * Where the game server lives: the page's own origin. In development the Vite
 * dev servers proxy /socket.io and /media to the game server; in production
 * one process serves everything. VITE_SERVER_URL overrides both.
 */
export function defaultServerUrl() {
    const env = import.meta.env;
    return env?.VITE_SERVER_URL || `${globalThis.location.protocol}//${globalThis.location.host}`;
}
//# sourceMappingURL=storage.js.map